import {
	// adminUpdateState,
	advanceSummitResolution,
	buyBattery,
	buyFactory,
	buyPR,
	donateEnergy,
	endTurn,
	makeDecision,
	makeDecisionSummitDraftCardId,
	makeDecisionTurnOrder,
	playCard,
	playEquipmentById,
	playSummitCard,
	stealCarbon,
	storeEnergy,
} from '@lc/const/socketEvent';
import { controller_game } from '@lc/controller/game';
import { CurrPlayerActionParams } from '@lc/interface/actionParams/types';
import { GameManager } from '@lc/interface/gameManager/types';

export async function executeActionSwitch(
	action: string,
	currPlayerActionParams: CurrPlayerActionParams,
	gameManager: GameManager
): Promise<boolean> {
	let stateChanged = false;

	switch (action) {
		case advanceSummitResolution:
			stateChanged = await controller_game.advanceSummitResolution(
				currPlayerActionParams,
				gameManager
			);
			break;
		case buyBattery:
			stateChanged = await controller_game.buyBattery(
				currPlayerActionParams,
				gameManager
			);
			break;
		case buyFactory:
			stateChanged = await controller_game.buyFactory(
				currPlayerActionParams,
				gameManager
			);
			break;
		case donateEnergy:
			stateChanged = await controller_game.donateEnergy(
				currPlayerActionParams,
				gameManager
			);
			break;
		case buyPR:
			stateChanged = await controller_game.buyPR(
				currPlayerActionParams,
				gameManager
			);
			break;
		case endTurn:
			stateChanged = await controller_game.endTurn(
				currPlayerActionParams,
				gameManager
			);
			break;
		case makeDecision:
			stateChanged = await controller_game.makeDecision(
				currPlayerActionParams,
				gameManager
			);
			break;
		case makeDecisionSummitDraftCardId:
			stateChanged = await controller_game.makeDecisionSummitDraftCardId(
				currPlayerActionParams,
				gameManager
			);
			break;
		case makeDecisionTurnOrder:
			stateChanged = await controller_game.makeDecisionTurnOrder(
				currPlayerActionParams,
				gameManager
			);
			break;
		case playCard:
			stateChanged = await controller_game.playCard(
				currPlayerActionParams,
				gameManager
			);
			break;
		case playEquipmentById:
			stateChanged = await controller_game.playEquipmentById(
				currPlayerActionParams,
				gameManager
			);
			break;
		case playSummitCard:
			stateChanged = await controller_game.playSummitCard(
				currPlayerActionParams,
				gameManager
			);
			break;
		case storeEnergy:
			stateChanged = await controller_game.storeEnergy(
				currPlayerActionParams,
				gameManager
			);
			break;
		case stealCarbon:
			stateChanged = await controller_game.stealCarbon(
				currPlayerActionParams,
				gameManager
			);
			break;
	}

	return stateChanged;
}
